module.exports = __webpack_public_path__ + "static/therapist-giving-cupping-treatment-patient-indoors-00ac308777b2d0c84a235f7bb6f8b23c.webp";